"use client";
import { CardBody, CardContainer, CardItem } from "./3d-card";

export function ThreeDCard2() {
  return (
    <CardContainer className="inter-var border-2 border-white rounded-xl">
     <CardBody className="relative group/card w-auto sm:w-[21rem] h-auto rounded-xl p-6 bg-white/50 backdrop-blur-[0.5px] border-white border-[1px] shadow-[0_0_0_2px_white]">
        <CardItem
          translateZ="100"

          className="w-full mt-4"
        >
          <img
            src="/assets/legal.svg"
            height="1000"
            width="1000"
            className="h-40 w-full object-cover rounded-xl group-hover/card:shadow-xl"
            alt="thumbnail"
          />
        </CardItem>
        <CardItem
          translateZ="50"
          className="text-xl"
          style={{ fontFamily: "Bricolage Grotesque, sans-serif",color: "#1F2B44" }}
        >
          Digital Legal Module
        </CardItem>
        <CardItem
          as="p"
          translateZ="60"
          className="text-left text-white text-sm max-w-sm mt-2"
          style={{ fontFamily: "Inter, sans-serif" }}
        >
          Automate digital and physical notices with tracking, trigger AI-powered legal outreach, ensure compliance, and monitor real-time case updates—all while leveraging pin-code level analytics to optimize legal recovery strategies.
        </CardItem>
        <div className="flex justify-between items-center mt-2">
          {/* <CardItem
            translateZ={20}
            translateX={-10}
            as="button"
            className="px-4 py-2 rounded-xl text-xs text-[#1F2B44] font-normal dark:text-black border-none"
          >
            Read more →
          </CardItem> */}
        </div>
      </CardBody>

    </CardContainer>
  );
}

export default ThreeDCard2;
